import fetchRequest from "./fetchRequest";

export const updateSection = (id, section, identifier) => {
    return fetchRequest(`/section/${identifier}/${id}`, {
        method: "PUT",
        body: JSON.stringify(section)
    });
};
